var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMIncapacidades(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 66 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2eccb6;}.cls-2{fill:#329be6;}.cls-3{fill:#0b5c96;}.cls-4{fill:#fff;}.cls-5{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m_incapacidades"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Incapacidades"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.28,32.72a.4.4,0,0,0,0,.56L12,45V21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.28.28a.4.4,0,0,0-.56,0L21,12H45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.72,65.72a.4.4,0,0,0,.56,0L45,54H21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M65.72,32.72,54,21V45L65.72,33.28A.4.4,0,0,0,65.72,32.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M51.5,51.5h-4L45,54h8.59a.41.41,0,0,0,.41-.41V45l-2.5,2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M51.5,14.5v4L54,21V12.41a.41.41,0,0,0-.41-.41H45l2.5,2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.5,51.5v-4L12,45v8.59a.41.41,0,0,0,.41.41H21l-2.5-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.5,14.5h4L21,12H12.41a.41.41,0,0,0-.41.41V21l2.5-2.5Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "51.5 18.5 51.5 47.5 54 45 54 21 51.5 18.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "47.5 14.5 45 12 21 12 18.5 14.5 47.5 14.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "14.5 18.5 12 21 12 45 14.5 47.5 14.5 18.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "18.5 51.5 21 54 45 54 47.5 51.5 18.5 51.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M14.5,14.5v37h37v-37ZM47,36.57a.39.39,0,0,1-.4.4H37v9.62a.39.39,0,0,1-.4.4H29.43a.39.39,0,0,1-.4-.4V37H19.41a.39.39,0,0,1-.4-.4V29.43a.39.39,0,0,1,.4-.4H29V19.41a.39.39,0,0,1,.4-.4h7.14a.39.39,0,0,1,.4.4V29h9.62a.39.39,0,0,1,.4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M46.59,29H37V19.41a.39.39,0,0,0-.4-.4H29.43a.39.39,0,0,0-.4.4V29H19.41a.39.39,0,0,0-.4.4v7.14a.39.39,0,0,0,.4.4H29v9.62a.39.39,0,0,0,.4.4h7.14a.39.39,0,0,0,.4-.4V37h9.62a.39.39,0,0,0,.4-.4V29.43A.39.39,0,0,0,46.59,29Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    width: 66,
    height: 66
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMIncapacidades);
export default __webpack_public_path__ + "static/media/m_incapacidades.deb1375b56dec84b3cd6ee771f7cf3e6.svg";
export { ForwardRef as ReactComponent };